var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('Toolbar',{attrs:{"back-btn":true}}),_c('FaqBar'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }